import type { EnvironmentSettings, Experience } from "@inter-ikea-space-platform/experience";
import { storageOnePackages as getPackages } from "@inter-ikea-space-platform/storageone";

export const storageOnePackages = (settings: EnvironmentSettings): Experience[] =>
  getPackages(settings, ["storageone-pax", "storageone-smastad"]);
